import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../assets/logo.png'


const _hoisted_1 = { class: "fixed top-0 left-0 w-full bg-black z-50 transition-all duration-300 h-20" }
const _hoisted_2 = { class: "container mx-auto px-6" }
const _hoisted_3 = { class: "flex items-center space-x-8 h-20 border-gray-100" }
const _hoisted_4 = { class: "flex items-center mx-auto md:mx-0 pl-10 md:pl-0" }
const _hoisted_5 = { class: "text-2xl md:text-3xl text-white" }
const _hoisted_6 = { class: "hidden md:flex items-center space-x-1 text-white" }
const _hoisted_7 = { class: "relative group" }
const _hoisted_8 = { class: "relative group" }
const _hoisted_9 = { class: "relative group" }
const _hoisted_10 = { class: "relative group" }
const _hoisted_11 = {
  key: 0,
  class: "fixed left-0 w-full bg-black z-50 transition-all duration-300"
}
const _hoisted_12 = { class: "container mx-auto px-6 py-6" }
const _hoisted_13 = { class: "hidden md:flex space-x-1 text-white text-left" }
const _hoisted_14 = { class: "relative group" }
const _hoisted_15 = { class: "relative group pl-48" }
const _hoisted_16 = { class: "relative group pl-48" }
const _hoisted_17 = { class: "relative group pl-48" }
const _hoisted_18 = {
  key: 1,
  class: "fixed left-0 w-full bg-black z-50 transition-all duration-300"
}
const _hoisted_19 = { class: "container mx-auto px-6 py-6" }
const _hoisted_20 = { class: "hidden md:flex space-x-1 text-white text-left" }
const _hoisted_21 = { class: "relative group" }
const _hoisted_22 = { class: "relative group pl-48" }
const _hoisted_23 = { class: "relative group pl-48" }
const _hoisted_24 = { class: "relative group pl-48" }
const _hoisted_25 = { class: "relative group pl-48" }
const _hoisted_26 = {
  key: 2,
  class: "fixed left-0 w-full bg-black z-50 transition-all duration-300"
}
const _hoisted_27 = { class: "container mx-auto px-6 py-6" }
const _hoisted_28 = { class: "hidden md:flex space-x-1 text-white text-left" }
const _hoisted_29 = { class: "relative group" }
const _hoisted_30 = { class: "relative group pl-48" }
const _hoisted_31 = {
  key: 3,
  class: "fixed left-0 w-full bg-black z-40 transition-all duration-300 position pt-20"
}
const _hoisted_32 = { class: "container mx-auto px-6 py-6" }
const _hoisted_33 = { class: "hidden md:flex space-x-1 text-white text-left" }
const _hoisted_34 = { class: "relative group" }
const _hoisted_35 = { class: "relative group pl-48" }
const _hoisted_36 = {
  key: 4,
  class: "fixed inset-0 bg-black z-40 md:hidden overflow-y-auto"
}
const _hoisted_37 = { class: "px-6 py-4" }
const _hoisted_38 = { class: "flex flex-col space-y-2" }
const _hoisted_39 = { class: "space-y-2" }
const _hoisted_40 = { class: "space-y-2" }
const _hoisted_41 = { class: "space-y-2" }
const _hoisted_42 = { class: "space-y-2" }
const _hoisted_43 = { class: "space-y-2" }
const _hoisted_44 = {
  key: 0,
  class: "pl-6 space-y-2"
}

import { ref, onMounted, onUnmounted, onBeforeUnmount } from "vue";
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

// 配置语言环境

export default /*@__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const { locale } = useI18n()
const router = useRouter()

const navigateTo = (path: string, query?: Record<string, string>) => {
  toggleMobileMenu()
  if (query) {
    router.push({ path, query })
  } else {
    router.push(path)
  }
}

// 切换中英文
const changeLanguage = (code: string) => {
  if (locale.value === 'zh') {
    locale.value = 'en'
    localStorage.setItem('lang', 'en')// 持久化，避免刷新页面后重置中英文
  } else {
    locale.value = 'zh'
    localStorage.setItem('lang', 'zh')// 持久化，避免刷新页面后重置中英文
  }
  
  // 手机端切换语言后关闭下拉框
  if(code === 'close'){
    toggleMobileMenu()
  }
}

// 三横线的显示与隐藏
const mobileMenuOpen = ref(false);
// 控制移动端导航菜单中各子菜单的显示与隐藏
const submenuOpen = ref({
  bike: false,
  accessory: false,
  equipment: false,
  community:false,
  about: false,
});
// 切换移动端导航菜单的显示与隐藏状态
const toggleMobileMenu = () => {
  mobileMenuOpen.value = !mobileMenuOpen.value;
  if (!mobileMenuOpen.value) {
    Object.keys(submenuOpen.value).forEach((key) => {
      submenuOpen.value[key] = false;
    });
  }
};
// 控制移动端菜单中的子菜单显示与隐藏，改变值函数
const toggleSubmenu = (menu: string) => {
  submenuOpen.value[menu] = !submenuOpen.value[menu];
};

// 二级菜单数据
const activeNav = ref('');
const toggleNav = (navName: string) => {
  if (activeNav.value === navName) {
    activeNav.value = '';
  } else {
    activeNav.value = navName;
  }
};

// 点击文档其他位置关闭下拉菜单
const menuRefBike = ref(null)
const menuRefAccessory = ref(null)
const menuRefApparel = ref(null)
const menuRefAbout = ref(null)
const handleClickOutside = (event) => {
  //  console.log(event.target)
  // console.log(menuRef.value)
  // if (menuRef.value && !menuRef.value.contains(event.target)) {
  //   activeNav.value = '';
  // }
  // const clickedOutside = [menuRefBike, menuRefAccessory, menuRefApparel, menuRefAbout].every(
  const clickedOutside = [menuRefAbout].every(
    ref => ref.value && !ref.value.contains(event.target)
  )
  // console.log(clickedOutside)
  // console.log(activeNav.value)
  if (clickedOutside) {
    activeNav.value = '';
  }
}

onMounted(() => {
  // 这段代码的主要功能是根据用户在页面上的滚动位置动态地为导航栏添加或移除阴影效果。具体来说，当页面的垂直滚动距离大于 100 像素时，导航栏会显示一个中等大小的阴影，使其在页面滚动时更加突出，提升用户体验。当滚动距离小于或等于 100 像素时，阴影效果会被移除，从而使页面顶部看起来更加简洁。
  window.addEventListener("scroll", () => {
    const nav = document.querySelector("nav");
    if (window.scrollY > 100) {
      nav?.classList.add("shadow-md");
    } else {
      nav?.classList.remove("shadow-md");
    }
  });
  // 点击文档其他位置关闭下拉菜单 ，使用addEventListener监听点击事件
  document.addEventListener('click', handleClickOutside)
  
});
onBeforeUnmount(() => {
  // 移除监听事件
  document.removeEventListener('click', handleClickOutside)
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[14] || (_cache[14] = _createElementVNode("img", {
              src: _imports_0,
              alt: "Logo",
              class: "mr-1 h-6 mt-[5px]",
              style: {
                width: 'auto',
                height: '40px',
                transform: 'translateY(-3px)',
              }
            }, null, -1)),
            _createElementVNode("h1", _hoisted_5, [
              _createVNode(_component_router_link, {
                to: "/",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleNav('')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('company.name')), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_router_link, {
                to: { path: '/product', query: { type: 'bikeormore' } },
                class: "py-[22px] pl-8 text-white transition-colors duration-300 cursor-pointer whitespace-nowrap !rounded-button inline-block hover:underline underline-offset-[5px]"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('header.bike_or_more')), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_router_link, {
                to: { path: '/product', query: { type: 'sale' } },
                class: "py-[22px] pl-8 text-white transition-colors duration-300 cursor-pointer whitespace-nowrap !rounded-button inline-block hover:underline underline-offset-[5px]"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('header.sale')), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_router_link, {
                to: "/newsPressReleases",
                class: "py-[22px] pl-8 text-white transition-colors duration-300 cursor-pointer whitespace-nowrap !rounded-button inline-block hover:underline underline-offset-[5px]"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('header.news_press_releases')), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                class: _normalizeClass(["py-[22px] pl-8 text-white transition-colors duration-300 cursor-pointer whitespace-nowrap !rounded-button inline-block hover:underline underline-offset-[5px]", { 'text-white': activeNav.value === 'about' }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleNav('about'))),
                ref_key: "menuRefAbout",
                ref: menuRefAbout
              }, _toDisplayString(_ctx.$t('header.about')), 3),
              _createElementVNode("i", {
                class: _normalizeClass([
                  'fas',
                  activeNav.value === 'about' ? 'fa-chevron-up' : 'fa-chevron-down','ml-1 text-xs'
                ])
              }, null, 2)
            ]),
            _createElementVNode("a", {
              class: "py-[22px] pl-8 text-white transition-colors duration-300 cursor-pointer whitespace-nowrap !rounded-button inline-block hover:underline underline-offset-[5px]",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (changeLanguage()))
            }, _toDisplayString(_ctx.$t('language.code')) + " | " + _toDisplayString(_ctx.$t('language.title')), 1)
          ]),
          _createElementVNode("div", { class: "md:hidden" }, [
            _createElementVNode("button", {
              onClick: toggleMobileMenu,
              class: "p-2 text-gray-700 hover:text-gray-900 rounded-md transition-all duration-200 !rounded-button whitespace-nowrap"
            }, _cache[15] || (_cache[15] = [
              _createElementVNode("i", { class: "fas fa-bars text-xl text-white" }, null, -1)
            ]))
          ])
        ])
      ])
    ]),
    (activeNav.value === 'bike')
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_router_link, {
                  to: "/roadBike",
                  class: "md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.road_bike')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_router_link, {
                  to: "/mountainBike",
                  class: "md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.mountain_bike')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_router_link, {
                  to: "/foldingBike",
                  class: "md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.folding_bike')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_router_link, {
                  to: "/kidsBike",
                  class: "md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.kids_bike')), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (activeNav.value === 'accessory')
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_router_link, {
                  to: "/handlebar",
                  class: "md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.handlebar')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "/carBell",
                  class: "md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.car_bell')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "/carLock",
                  class: "md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.car_lock')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_router_link, {
                  to: "/brake",
                  class: "md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.brake')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "/variableSpeed",
                  class: "md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.variable_speed')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_router_link, {
                  to: "/crank",
                  class: "md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.crank')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "/chain",
                  class: "md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.chain')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "/pedal",
                  class: "md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.pedal')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_router_link, {
                  to: "/seat",
                  class: "md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.seat')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "/seatPost",
                  class: "md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.seat_post')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_router_link, {
                  to: "/wheels",
                  class: "md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.wheels')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "/wheelSet",
                  class: "md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.wheel_set')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "/stickers",
                  class: "md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.stickers')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "/bicyclePump",
                  class: "md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.bicycle_pump')), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (activeNav.value === 'apparel')
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_router_link, {
                  to: "/helmets",
                  class: "md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.helmets')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "/shoes",
                  class: "md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.shoes')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "/clothing",
                  class: "md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.clothing')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_router_link, {
                  to: "/other",
                  class: "md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.other')), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (activeNav.value === 'about')
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_component_router_link, {
                  to: "/cultureAndValues",
                  class: "md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.culture_and_values')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: { path: '/cultureAndValues', hash: '#milestone' },
                  class: "md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.milestone')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: { path: '/cultureAndValues', hash: '#leadershipTeam' },
                  class: "md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.leadership_team')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "/ourBusiness",
                  class: "md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.our_business')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_router_link, {
                  to: "/securityCheck",
                  class: "md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.security_check')), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (mobileMenuOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "pt-10 pb-4 px-6 border-b border-gray-100" }, null, -1)),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("button", {
                  class: "w-full flex items-center justify-between px-4 py-2 text-white hover:text-gray-900 hover:bg-gray-100 rounded-md text-left",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (navigateTo('/')))
                }, _toDisplayString(_ctx.$t('header.homePage')), 1)
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("button", {
                  class: "w-full flex items-center justify-between px-4 py-2 text-white hover:text-gray-900 hover:bg-gray-100 rounded-md text-left",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (navigateTo('/product', { type: 'bikeormore' })))
                }, _toDisplayString(_ctx.$t('header.bike_or_more')), 1)
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("button", {
                  class: "w-full flex items-center justify-between px-4 py-2 text-white hover:text-gray-900 hover:bg-gray-100 rounded-md text-left",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (navigateTo('/product', { type: 'sale' })))
                }, _toDisplayString(_ctx.$t('header.sale')), 1)
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("button", {
                  class: "w-full flex items-center justify-between px-4 py-2 text-white hover:text-gray-900 hover:bg-gray-100 rounded-md text-left",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (navigateTo('/newsPressReleases')))
                }, _toDisplayString(_ctx.$t('header.news_press_releases')), 1)
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", {
                  class: "flex items-center justify-between px-4 py-2 text-white hover:text-white hover:bg-black rounded-md cursor-pointer",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (toggleSubmenu('about')))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('header.about')), 1),
                  _createElementVNode("i", {
                    class: _normalizeClass([
                  'fas',
                  submenuOpen.value.about ? 'fa-chevron-up' : 'fa-chevron-down',
                ])
                  }, null, 2)
                ]),
                (submenuOpen.value.about)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _createElementVNode("button", {
                        class: "w-full block px-4 py-2 text-white hover:text-gray-900 hover:bg-gray-100 rounded-md text-left",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (navigateTo('/cultureAndValues')))
                      }, _toDisplayString(_ctx.$t('header.culture_and_values')), 1),
                      _createElementVNode("button", {
                        class: "w-full block px-4 py-2 text-white hover:text-gray-900 hover:bg-gray-100 rounded-md text-left",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (navigateTo('/cultureAndValues')))
                      }, _toDisplayString(_ctx.$t('header.milestone')), 1),
                      _createElementVNode("button", {
                        class: "w-full block px-4 py-2 text-white hover:text-gray-900 hover:bg-gray-100 rounded-md text-left",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (navigateTo('/cultureAndValues')))
                      }, _toDisplayString(_ctx.$t('header.leadership_team')), 1),
                      _createElementVNode("button", {
                        class: "w-full block px-4 py-2 text-white hover:text-gray-900 hover:bg-gray-100 rounded-md text-left",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (navigateTo('/ourBusiness')))
                      }, _toDisplayString(_ctx.$t('header.our_business')), 1),
                      _createElementVNode("button", {
                        class: "w-full block px-4 py-2 text-white hover:text-gray-900 hover:bg-gray-100 rounded-md text-left",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (navigateTo('/securityCheck')))
                      }, _toDisplayString(_ctx.$t('header.security_check')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("a", {
                class: "flex items-center justify-between px-4 py-2 text-white hover:text-gray-900 hover:bg-gray-100 rounded-md cursor-pointer",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (changeLanguage('close')))
              }, _toDisplayString(_ctx.$t('language.code')) + " | " + _toDisplayString(_ctx.$t('language.title')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})